/**
 * @Author: v_jppjpeng
 * @Date: 2023-08-15 20:13:16
 * @Explain: 偏好设置
 */
import { HttpResponse } from '../data.d';
import http from '../http';

const MODEL = '/preference';

export default {
  // 列表
  getList(data: Record<any, any>): Promise<HttpResponse> {
    return http.post(`${MODEL}/list`, data, {
      params: { switchReqToUnderline: true, ver: 'v2' },
    });
  },
  // 添加
  onAdd(data: Record<any, any>) {
    return http.post(`${MODEL}/add`, data);
  },
  // 编辑
  onEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/update`, data);
  },
  // 保存
  onSave(data: Record<any, any>) {
    return http.post(`${MODEL}/save`, data);
  },
  // 删除
  onDel(data: { id: number[] }) {
    return http.post(`${MODEL}/deleted`, data);
  },
};
